import { MessageCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useChatStore } from '@/stores/chatStore'

export function ChatButton() {
  const { isOpen, setOpen, unreadCount, isOnline } = useChatStore()

  return (
    <button
      onClick={() => {
        setOpen(!isOpen)
        if (!isOpen) {
          useChatStore.getState().markAllRead()
        }
      }}
      className={cn(
        'w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-200',
        'hover:scale-105 active:scale-95',
        isOpen
          ? 'bg-secondary-700 text-white'
          : 'bg-primary-600 text-white hover:bg-primary-700'
      )}
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
    >
      <MessageCircle className="w-6 h-6" />

      {/* Online/Offline indicator */}
      <span
        className={cn(
          'absolute top-0 right-0 w-3.5 h-3.5 rounded-full border-2 border-white',
          isOnline ? 'bg-green-500' : 'bg-secondary-400'
        )}
      />

      {/* Unread badge */}
      {unreadCount > 0 && !isOpen && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center px-1">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  )
}
